import React, { ChangeEvent } from "react";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";
interface TimePickerProps extends RowItem, Omit<InterfaceComponentsProps,"Icon"> {
    onChange?: (text: string,) => void,
    onBlur?: () => void,  
    tableClass?: string,
    model: string,
    placeholder?: string,    
    required?: boolean,
}
function TimePicker(props: TimePickerProps) {

    function handler(event: ChangeEvent<HTMLInputElement>) {
        const { value } = event.target;
        if (props.onChange && typeof props.onChange == "function")
            props.onChange(value);
    }

    function blurhandler(event: ChangeEvent<HTMLInputElement>) {
        const { value } = event.target;
        if (value == '' && props.onChange)
            props.onChange(app.now());

    }
    var datePicker = <input
        id={props.id ? props.id : "date" + props.label}
        type="time"
        value={props.model}
        className={`form-control form-control-sm rounded ${props.required && !props.model ? " is-invalid  border-1" : props.isTable ? " border-1 text-center bg-body-tertiary " + props.tableClass : "border-0 " + props.class}`}
        disabled={props.disabled}
        onChange={handler}
        onBlur={blurhandler}
        placeholder={app.translate(props.placeholder)}
        max="3000-12-31"
        required={props.required}
        autoComplete="off"
    />;

    return (
        props.isTable ? datePicker :
            <div>
                <label className={props.labelClass || "fw-semibold text-primary-emphasis "}>{app.translate(props.label)}</label>
                <div className="input-group border rounded">
                    {datePicker}
                </div>
            </div>
    );
}

TimePicker.defaultProps = {
    label: "",
    model: new Date(),
    placeholder: "",
    class: " ",
    disabled: false,
    required: false,
    isTable: false
}

export default TimePicker;